// Usage settings tab — token usage summary. COMING SOON: per-user token aggregation isn't built yet
// (only per-message usage exists). We render the intended metrics as clearly-labelled placeholders
// rather than fake numbers, so the section reads as "not yet wired", not broken.

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import { SERIF_HEADING } from '../theme'

const METRICS = [
  { label: 'Input tokens', hint: 'Tokens Ros has read across your chats.' },
  { label: 'Output tokens', hint: 'Tokens Ros has generated.' },
  { label: 'Cached input tokens', hint: 'Input served from cache (cheaper).' },
  { label: 'Total tokens used', hint: 'Across all of your activity.' },
]

export function SettingsUsage() {
  return (
    <Box sx={{ maxWidth: 720, mx: 'auto', px: 5, py: 5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5 }}>
        <Typography variant="h5" sx={SERIF_HEADING}>Usage</Typography>
        <Box component="span" sx={{ px: 1, py: 0.25, borderRadius: 1, bgcolor: 'rgba(87,82,74,0.10)', color: 'text.secondary', fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.04em' }}>COMING SOON</Box>
      </Box>
      <Typography sx={{ color: 'text.secondary', mb: 3 }}>
        Token usage across your chats — input, output, cached, and total. We're wiring this up.
      </Typography>

      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
        {METRICS.map(m => (
          <Paper key={m.label} variant="outlined" sx={{ borderRadius: 2, p: 2.25 }}>
            <Typography sx={{ fontSize: '0.82rem', color: 'text.secondary' }}>{m.label}</Typography>
            <Typography sx={{ fontSize: '1.6rem', fontWeight: 700, color: 'text.disabled', my: 0.25 }}>—</Typography>
            <Typography sx={{ fontSize: '0.72rem', color: 'text.disabled' }}>{m.hint}</Typography>
          </Paper>
        ))}
      </Box>
    </Box>
  )
}
